import * as React from 'react';
import './App.css';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@material-ui/styles';
import Navigation from './navigation/index';
import theme from './theme';
import { PersistGate } from 'redux-persist/integration/react'
import configureStore from './redux/store';
import ErrorBoundary from './components/ErrorBoundary';

function App() {
  const { store, persistor } = configureStore();
  if (typeof window !== 'undefined') {
    (window as any).__APP_STORE__ = store;
  }
  return (
    <ErrorBoundary>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ThemeProvider theme={theme}>
            <Navigation />
          </ThemeProvider>
        </PersistGate>
      </Provider>
    </ErrorBoundary>
  );
}

export default App;
